import { dataLoadUsersAsync, dataLoadSomeUsersAsync } from './dataApi';

const useWindow = true;

const isAdminEmailSet = new Set([
  'rgj367@motorolasolutions.com',
  'abs010@motorolasolutions.com',
  'gqk436@motorolasolutions.com',
  'wcg834@motorolasolutions.com',
  'dipal.choksi@motorolasolutions.com',
  'veronica.thomas@motorolasolutions.com',
  'pawel.stepniewski@motorolasolutions.com',
  'bogdan.stepien@motorolasolutions.com'
]);

export const isLoggedIn = () => {
  let email;
  let token;
  let rights;
  let hasRights;
  if (useWindow) {
    email = window._loginEmail;
    token = window._loginToken;
    rights = window._loginRights;
  } else {
    // eslint-disable-next-line
    email = localStorage.getItem('loginEmail');
    // eslint-disable-next-line
    token = localStorage.getItem('loginToken');
    // eslint-disable-next-line
    rights = localStorage.getItem('userData');
  }
  hasRights = rights && Object.keys(rights).reduce((acc, key) => {
    return acc || rights[key];
  }, false);

  return hasRights;
};

const recursiveGetSubordinates = (users, managerCoreId, managedUsers) => {
  users.forEach(user => {
    if (user.parent === managerCoreId) {
      managedUsers.push(user);
      recursiveGetSubordinates(users, user.coreId, managedUsers);
    }
  });
};

export const getRoles = async (email) => {
  const emailLower = email.toLowerCase();
  const coreId = emailLower.split('@')[0];
  const usersArr = await dataLoadSomeUsersAsync(coreId, null);
  const userObj = usersArr && usersArr.length > 0 ? usersArr[0] : null;
  const allUsers = await dataLoadUsersAsync();
  const teamUsers = await dataLoadSomeUsersAsync(null, coreId);
  const isAdmin = isAdminEmailSet.has(email.toLowerCase());

  //Return an anonymous user object if the user is not found in the json file.
  if(!userObj) {
    return { isAdmin: false, isManager: false, isUser: true, managedUsers: [], userObj: {coreId: coreId, name: coreId, parent: "", teamName: "", email: emailLower}, coreId };
  }

  let isManager = false;
  let isUser = !!userObj;
  let managedUsers = [];
  
  if (userObj) {
    isManager = teamUsers && teamUsers.length > 0;
    if (isManager) {
      //recursiveGetSubordinates(allUsers, coreId, managedUsers);
      managedUsers = teamUsers;
    }
  }

  return { isAdmin, isManager, isUser, allUsers, managedUsers, userObj, coreId };
};

